import Request from './request'
import store from '@/store.js'
import i18n from '@/i18n'
import snackbar from '@/plugins/snackbar'

async function fetch(id) {
  return Request('get', "api/sorting-tasks/index?stock_id=" + id);
}

async function add(data) {// 新增分拣任务
  return Request('post', "api/sorting-tasks/add", data);
}

async function edit(data) {//编辑分拣任务
  return Request('post', "api/sorting-tasks/edit", data);
}

async function saveTaskCategories(data) {//保存任务详情
  return Request('post', "api/sorting-tasks/edit", data);
}

async function materialImport(stockId, file) {// 导入商品
  var data = new FormData();
  data.append("excel", file);
  return Request('post', "api/sorting-tasks/sorting-task-material-import?stock_id=" + stockId, data);
}

async function materialExport(data) {// 导出商品
  store.dispatch('fullscreenLoading')
  const response = await Request('get', 'api/sorting-tasks/sorting-task-material-export', data)
  if (response.data && response.data.status.isOK()) {
    snackbar.info(i18n.t('Export.recordedHint'))
  }
  store.dispatch('fullscreenLoadingStop')
  return response
}

async function positionImport(stockId, file) {// 导入库位
  var data = new FormData();
  data.append("excel", file);
  return Request('post', "api/sorting-tasks/sorting-task-position-import?stock_id=" + stockId, data);
}

async function positionExport(data) {// 导出库位
  store.dispatch('fullscreenLoading')
  const response = await Request('get', 'api/sorting-tasks/sorting-task-position-export', data)
  if (response.data && response.data.status.isOK()) {
    snackbar.info(i18n.t('Export.recordedHint'))
  }
  store.dispatch('fullscreenLoadingStop')
  return response
}

async function delTask(taskId) {//保存任务详情
  return Request('get', "api/sorting-tasks/delete/" + taskId);
}

export default {
  fetch,
  add,
  edit,
  saveTaskCategories,
  materialImport,
  materialExport,
  positionImport,
  positionExport,
  delTask,
};